import ButtonCircle from '../ButtonCircle';
import Tag from '../Tag/Tag';
import { type LandingTileProps } from './LandingTiles.types';

const LandingTile: React.FC<LandingTileProps> = ({
  title,
  disabled,
  extraClasses,
  subtitle,
  content,
  link,
  icon,
  includeCircle,
  headingSize,
  metadata,
  tag,
  size,
}) => {
  const TileTag = link && !disabled ? 'a' : 'div';
  const { url, targetAttr } = link || {};

  const defaultHeadingSize = size === 'small' ? 'h5' : 'h4';

  return (
    <div
      className={`link-tile__outer link-tile__outer--${size}`}
      data-aos="fade-up"
    >
      <TileTag
        className={`link-tile ${extraClasses || ''}`}
        href={url || ''}
        target={targetAttr || ''}
      >
        {icon && (
          <div
            className="link-tile__icon"
            dangerouslySetInnerHTML={{ __html: icon }}
          />
        )}

        {tag && <Tag {...tag} />}

        {subtitle && <div className="link-tile__subtitle h6">{subtitle}</div>}

        {title && (
          <div
            className={`link-tile__title ${headingSize || defaultHeadingSize}`}
          >
            {title}
          </div>
        )}

        {metadata && <p className="link-tile__metadata">{metadata}</p>}

        {content && (
          <div
            className="link-tile__summary"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}

        {includeCircle && (
          <span className="link-tile__button button--secondary-alt">
            <ButtonCircle
              arrowHeight={17}
              arrowWidth={21}
              arrowFill="#ffffff"
            />
          </span>
        )}
      </TileTag>
    </div>
  );
};

export default LandingTile;
